import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import Button from 'atoms/button';
import { setIncompleteItems } from 'store/reducers/checkout';

import AppointmentItem from './AppointmentItem';
import { hasAddOnBeenAdded } from './util';

export default function AppointmentItemsList() {
  const dispatch = useDispatch();
  const { service, completeItems, appointment, incompleteItems } = useSelector(
    (state) => state.checkout
  );
  const { locations: providerLocations } = useSelector(
    (state) => state.provider
  );

  // Provider's services, filtered by animal type
  const serviceDropdownOptions = providerLocations[0].services
    .filter((el) => !el.isAddOn)
    .filter((el) => el.animal?.type?.id === appointment.animal?.type?.id)
    .map(({ name, uuid, price, size }) => ({ name, uuid, price, size }));

  // Provider's add-ons, filtered by animal type
  const addOns = providerLocations[0].services
    .filter((el) => el.isAddOn)
    .filter((el) => el.animal?.type?.id === appointment.animal?.type?.id);

  // We filter out already selected add-ons
  const addOnsDropdownOptions = addOns
    .filter((el) => hasAddOnBeenAdded(el, completeItems))
    .map(({ name, uuid, price, size }) => ({ name, uuid, price, size }));

  const serviceOptions = serviceDropdownOptions.map((option) => ({
    ...option,
    name: option.size?.value
      ? `${option.name} - ${option.size?.value}`
      : option.name,
  }));

  const addOnsOptions = addOnsDropdownOptions.map((option) => ({
    ...option,
    name: option.size?.value
      ? `${option.name} - ${option.size?.value}`
      : option.name,
  }));

  const canAddNewItem = addOnsDropdownOptions.length > 0;

  const onAddItem = ({ isCustomItem }) => {
    dispatch(
      setIncompleteItems([...incompleteItems, { uuid: uuidv4(), isCustomItem }])
    );
  };

  return (
    <div className="mb-12 p-24 border-light-purple radius-24 flex-column align-start">
      <div className="flex-column w-100">
        <AppointmentItem
          // We use a key here to make the component re-render on change.
          // This way the service name clears compleatly when hitting backspace
          key={service?.uuid || 'service'}
          options={serviceOptions}
          leftColumnLabel="Service"
          className="mb-15"
          rightColumnLabel="Cost"
          isService
          item={service}
          disableDeletion
        />
        {incompleteItems.map((addOn, i) => (
          <AppointmentItem
            focus={i === incompleteItems.length - 1}
            key={addOn?.uuid}
            item={addOn}
            className="mb-15"
            options={addOnsOptions}
          />
        ))}
      </div>
      <div className="flex-row">
        {canAddNewItem && (
          <Button
            className="pointer fw-400 mr-10"
            onClick={() => onAddItem({ isCustomItem: false })}
            variant="white-outlined"
            size="small"
            text="+ Add service" // This actually adds and add-on, but there's no concept of add-on for users
          />
        )}
        <Button
          className="pointer fw-400"
          onClick={() => onAddItem({ isCustomItem: true })}
          variant="white-outlined"
          size="small"
          text="+ Add custom item"
        />
      </div>
    </div>
  );
}
